import { Reveal } from "./motion";

const STUDIO_IMG =
  "https://customer-assets-jt897jd0.emergentagent.net/job_emergent-coffee-rsvp/artifacts/hd1hp0qv_IMG_1444%202.webp";

export const WhatWorkingOn = () => (
  <section id="working-on" data-testid="working-on" className="bg-mushroom-light px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="lg:col-span-5 order-2 lg:order-1">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] aspect-[4/5] shadow-xl">
            <img src={STUDIO_IMG} alt="Women gathered around a table working together at Thump at The Grove" className="w-full h-full object-cover" loading="lazy" />
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7 order-1 lg:order-2">
        <Reveal>
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.24em] text-mushroom-deep">
            what you're working on
          </span>
          <h2 className="mt-4 font-display font-black lowercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
            bring one real project
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-7 text-lg sm:text-2xl font-medium leading-[1.2] text-ink/85 max-w-2xl">
            bring one creative project you want to move forward. a business, a build, code, art,
            writing, a launch, whatever is real for you. no project this week? come anyway. there's
            always a prompt to work with, or space to journal and get clear.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
